<template>
  <settings-modal class="payment-order-cancel-modal">
    <template slot="heading">Cancel payment order {{ paymentOrderId }}?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_ORDER_UPDATE } from '@/events/paymentOrders'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentOrderApi from '@/services/Api/PaymentOrderApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentOrderCancelModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        paymentOrderCancelApiRequest: new ApiRequest(PaymentOrderApi.cancel)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentOrderId () {
        return this.modal.data.paymentOrderId
      },
      loading () {
        return this.paymentOrderCancelApiRequest.loading
      },
      error () {
        return this.paymentOrderCancelApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.cancelPaymentOrder(this.paymentOrderId)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_ORDER_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment order has been successfully canceled.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelPaymentOrder (paymentOrderId) {
        return this.paymentOrderCancelApiRequest.execute(paymentOrderId)
      }
    }
  }
</script>

<style lang="scss">
  .payment-order-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
